import { Vue } from 'vue-property-decorator'
import moment from 'moment'

export default class GlobalMixins extends Vue {
    formError: false | string = false
	formMessage: false | string = false
	search: string = ''
	sortedBy: string = ''
	sortDirection: 'normal' | 'reverse' = 'normal'

	slugify(string: string): string {
		const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
		const p = new RegExp(a.split('').join('|'), 'g')
		
		return string.toString().toLowerCase()
			.replace(/\s+/g, '-')
			.replace(p, c => b.charAt(a.indexOf(c)))
			.replace(/&/g, '-and-')
			.replace(/[^\w\-]+/g, '')
			.replace(/\-\-+/g, '-')
			.replace(/^-+/, '')
			.replace(/-+$/, '')
	}
	sort(category: string): void {
		if (category === this.sortedBy) {
			this.sortDirection = this.sortDirection === 'normal' ? 'reverse' : 'normal'
		} else {
			this.sortedBy = category
			this.sortDirection = 'normal'
		}
	}
	timeSinceTestFilledIn(testFilledInAt: string, capitalize?: boolean): string {
		moment.locale('nl')

		let timeSince = moment(new Date(testFilledInAt)).fromNow()

		if (capitalize) {
			timeSince = timeSince.charAt(0).toUpperCase() + timeSince.substring(1)
		}
		
		return timeSince
	}
	timeStampNormalized(testFilledInAt: string): string {
		moment.locale('nl')

		return moment(new Date(testFilledInAt)).format('D MMMM YYYY, H:mm')
	}
    returnErrorByCode(errorCode: number): string {
        switch(errorCode) {
			case 10325:
				return 'Dit e-mail adres word al gebruikt voor een andere kandidaat'
			case 10350:
				return 'Een kandidaat met dit e-mail adres bestaat al'
			case 10351:
				return 'Een klant/functie met soortgelijke informatie bestaat al'
            case 10103:
            case 30000:
                return 'Het opgegeven e-mail adres of wachtwoord is onjuist.'
            case 30001:
                return 'Er is geen e-mail adres ingevuld.'
            case 30002:
                return 'Het ingevulde e-mail adres is ongeldig.'
            case 30003:
				return 'Er is geen wachtwoord ingevuld.'
			case 30100:
				return 'Je inlog sessie is verlopen, log opnieuw in.'
            default: 
                return 'Er is een onbekende fout opgetreden.'
        }
    }
	validateEmail(email: string): boolean {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
	}
	phoneContainsLetters(phone: string) {
		return RegExp(/[A-Za-z]/).test(phone)
	}
	checkIfSessionExpired(errorCode: number, alternateFunction: Function) {
		if (errorCode === 30100) {
			this.$store.dispatch('setLoginError', this.returnErrorByCode(30100))

			this.$router.push({name: 'login'})
		} else {
			alternateFunction()
		}
	}
}
